import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedRulePriceInsurance.errors.";

const insuranceRegisterSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "insurance_field" },
);

export const priceInsuranceSchema = z.object({
  id: z.string().optional(),
  insuranceRegister: insuranceRegisterSchema,
});

export type TPriceInsuranceForm = z.infer<typeof priceInsuranceSchema>;
